import type { Offer } from '@psp-aggregator/sdk';

import type { OfferLegKey } from '../model/legs';

import {
  type OfferCustomField,
  type OfferDraft,
  type OfferLegDraft,
  type OfferRollingReserve,
  offerToDraft,
} from './offerDraft';
import { regionsForCountries } from './regions';

export type {
  OfferCustomField,
  OfferLegDraft,
  OfferRollingReserve,
} from './offerDraft';

export interface OfferViewAttributes {
  base_currency: string;
  chargeback: string;
  countries: string[];
  currencies: string[];
  custom_fields: OfferCustomField[];
  details: string;
  guarantee_amount: string;
  integration_methods: string[];
  legs: Record<OfferLegKey, OfferLegDraft>;
  payment_methods: string[];
  refund: string;
  regions: string[];
  restricted_countries: string[];
  rolling_reserve: OfferRollingReserve;
  traffic_type: string;
}

const unique = (values: string[]): string[] => [
  ...new Set(values.filter(Boolean)),
];

export const getOfferAttributes = (offer: Offer): OfferViewAttributes => {
  const draft: OfferDraft = offerToDraft(offer);

  return {
    base_currency: draft.base_currency,
    chargeback: draft.chargeback,
    countries: draft.countries,
    currencies: draft.currencies,
    custom_fields: draft.custom_fields,
    details: draft.details,
    guarantee_amount: draft.guarantee_amount,
    integration_methods: draft.integration_methods,
    legs: draft.legs,
    payment_methods: unique([
      ...draft.legs.payin.methods,
      ...draft.legs.payout.methods,
    ]),
    refund: draft.refund,
    regions: regionsForCountries(draft.countries),
    restricted_countries: draft.restricted_countries,
    rolling_reserve: draft.rolling_reserve,
    traffic_type: draft.traffic_type,
  };
};

export const getOfferDisplayName = (
  offer: Pick<Offer, 'alias' | 'id' | 'name'>,
): string => offer.name || offer.alias || offer.id;
